import React from "react";
import "./Navbar.css";
import "../../styles/colors.css";

export default function Navbar() {
  return (
    <header className="background--light-mode">
      <h1 className="header__title headline--light-mode">Crypto Tracker</h1>
      <nav></nav>
    </header>
  );
}
